import React from 'react';
import { Alert, Button, Typography } from '@mui/material';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';

const RSABanner = ({ setShowRSA }) => (
  <Alert icon={<LocalOfferOutlinedIcon fontSize="inherit" />} severity="info">
    <Typography variant="h4" align="left">
      Special Offer!
    </Typography>
    <Typography variant="body2" align="left">
      Bundle 24/7 Roadside Assistance to your loan for added peace of mind.
    </Typography>
    <Button
      variant="outlined"
      color="primary"
      size="small"
      onClick={() => setShowRSA(true)}
      sx={{ mt: 0.5, borderRadius: '4px' }}
    >
      Learn more
    </Button>
  </Alert>
);

export default RSABanner;
